import React, { useMemo } from 'react';
import { Select } from '@televet/kibble-ui/build/components/Select';
import { MenuItemProps } from '@televet/kibble-ui/build/components/Menu/components/MenuItem';
import { daysOfWeek } from 'shared/constants/daysOfWeek';

interface RepeatWeeklyDaySelectProps {
  repeatIntervalSelectedDay: number | undefined;
  setRepeatIntervalSelectedDay: (val: number | undefined) => void;
  isWeeklyDayInvalid: boolean;
}
const REPEATS_ON_WEEKDAYS = [...daysOfWeek].map((day, index) => ({ label: day, value: index }));

const RepeatWeeklyDaySelect: React.FC<RepeatWeeklyDaySelectProps> = ({
  repeatIntervalSelectedDay,
  setRepeatIntervalSelectedDay,
  isWeeklyDayInvalid,
}) => {
  const repeatIntervalWeekdays: MenuItemProps[] = useMemo(
    () =>
      REPEATS_ON_WEEKDAYS.map((day) => ({
        label: day.label,
        value: day.value.toString(),
        isSelected: repeatIntervalSelectedDay === day.value,
      })),
    [repeatIntervalSelectedDay],
  );

  return (
    <Select
      data-testid="custom-task-modal-weekly-interval-select"
      listProps={{
        onSelect: (selectedItem: MenuItemProps): void => {
          if (selectedItem.value || selectedItem.value === '0') {
            setRepeatIntervalSelectedDay(parseInt(selectedItem.value));
          }
        },
      }}
      placeholder="Repeat"
      label="Repeats On"
      errorText="Please select a day of the week"
      isRequired={true}
      options={repeatIntervalWeekdays}
      value={repeatIntervalSelectedDay?.toString() || ''}
      isInvalid={isWeeklyDayInvalid}
    />
  );
};

export default RepeatWeeklyDaySelect;
